import { waitForAnimations } from "../utils/animation.js";
import type { HelperAwaiter, AnimatedElementValue } from "./useDomAnimationHelper.types.js";

/**
 *
 *
 *
 */
export const normalizeElements = (elementOrElements: AnimatedElementValue): Element[] => {
  if (!elementOrElements) return [];
  return "ELEMENT_NODE" in elementOrElements
    ? [elementOrElements]
    : Array.from(elementOrElements).filter(Boolean);
};

/**
 *
 *
 *
 *
 */
export const onAnimationFrame = (): HelperAwaiter => (activating, setter) =>
  new Promise((resolve) => {
    /*                                     */
    requestAnimationFrame(() => resolve(setter(activating)));
  });

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const onElementAnimated =
  (
    getAnimatedElements: () => AnimatedElementValue,
    getAnimationsOptions?: Parameters<HTMLElement["getAnimations"]>[0],
  ): HelperAwaiter =>
  async (activating, setter) => {
    /*                       */
    const elements = normalizeElements(getAnimatedElements());

    /*                                               */
    await waitForAnimations(elements, getAnimationsOptions);
    setter(activating);
  };

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const onTimeout =
  (timeout: number): HelperAwaiter =>
  (value, setter) =>
    new Promise((r) => setTimeout(() => r(setter(value)), timeout));

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const OnImmediate: HelperAwaiter = (activating, setter) =>
  Promise.resolve(setter(activating));

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const OnAnimationFrame: HelperAwaiter = onAnimationFrame();
